import { Button, Box } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { useParams, Navigate } from "react-router-dom";

export const UBPageSelect = () => {
  const { dashboard: pDashboard } = useParams();
  const { pathname } = useLocation();

  const path = pathname.split("/").filter((x) => x).pop();

  let navigate = useNavigate()

  const handlePageSelect = (path) => {
      navigate(path);
  };

  return (
    <Box sx={{ flexGrow: 1, justifyContent: 'right', mr: 4, display: { xs: 'none', md: 'flex' } }}>
      <Button
        onClick={() => handlePageSelect(`/unionbank/${pDashboard}`)}
        sx={{ color: 'white', display: 'block', fontWeight: path === pDashboard ? 'bold' : '' }}
      >
        Dashboard
      </Button>

      <Button
        onClick={() => handlePageSelect(`/unionbank/${pDashboard}/summary`)}
        sx={{ color: 'white', display: 'block', fontWeight: path === "summary" ? 'bold' : '' }}
      >
        Summary
      </Button>

      <Button
        onClick={() => handlePageSelect(`/unionbank/${pDashboard}/detail`)}
        sx={{ color: 'white', display: 'block', fontWeight: path === "detail" ? 'bold' : '' }}
      >
        Detail
      </Button>

      <Button
        onClick={() => handlePageSelect(`/unionbank/${pDashboard}/hourly`)}
        sx={{ color: 'white', display: 'block', fontWeight: path === "hourly" ? 'bold' : '' }}
      >
        Hourly
      </Button>

      <Button
        onClick={() => handlePageSelect(`/unionbank/${pDashboard}/daily`)}
        sx={{ color: 'white', display: 'block', fontWeight: path === "daily" ? 'bold' : '' }}
      >
        Daily
      </Button>

      <Button
        onClick={() => handlePageSelect(`/unionbank/${pDashboard}/error`)}
        sx={{ color: 'white', display: 'block', fontWeight: path === "error" ? 'bold' : '' }}
      >
        Error
      </Button>
    </Box>
  );
};